import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  body: {
    height: "calc (100vh - 300px)",
    display: "flex",
    padding: "20px",
    margin: "0 auto",
    maxWidth: "1400px",
  },
  form: {
    backgroundColor: "#EEF1F2",
    borderRadius: "6px",
    padding: "20px",
    marginTop: "20px",
    maxWidth: "950px",
    display: "flex",
    flexWrap: "wrap",
    gap: "20px 15px",

    "& h2": {
      width: "100%",
      fontFamily: "Roboto",
      fontWeight: "400",
      fontSize: "24px",
      padding: "20px",
      borderBottom: "1.5px solid #BBB",
      marginBottom: "20px",
    },
  },

  saveButton: {
    display: "block",
    textAlign: "center",
    backgroundColor: "#002F49",
    width: "165px",
    height: "46px",
    fontSize: "1.4rem",
    lineHeight: "20px",
    color: "white",
    textTransform: "capitalize",
    margin: "20px 50px 20px auto",

    "&:hover": {
      background: "#001E38",
    },
  },
}));

export default useStyles;
